import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/index.js';

class CustomStepButton extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "markAsComplete", e => {
      const {
        clickHandler
      } = this.props;
      this.setState({
        processing: true
      });
      clickHandler(e);
    });
    this.state = {
      processing: false
    };
  }
  render() {
    const {
      completedOn,
      markAsCompleteLabel,
      buttonLabel
    } = this.props;
    const {
      processing
    } = this.state;
    const btnLabel = buttonLabel || markAsCompleteLabel;
    if (completedOn) return null;
    return /*#__PURE__*/React.createElement(Button, {
      onClick: e => this.markAsComplete(e),
      label: btnLabel,
      variant: "neutral",
      spinner: processing,
      className: "slds-m-left--xx-small"
    });
  }
}
CustomStepButton.displayName = "CustomStepButton";
CustomStepButton.propTypes = {
  completedOn: PropTypes.string,
  markAsCompleteLabel: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  clickHandler: PropTypes.func
};
CustomStepButton.defaultProps = {
  completedOn: null,
  clickHandler: null,
  buttonLabel: null
};
var CustomStepButton$1 = CustomStepButton;

export { CustomStepButton$1 as default };
